import moment from "moment";
import React, { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Drawer from "react-bottom-drawer";
import DownloadDropDown from "../DownloadDropDown";
import { ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import di from "@frameworks/web/components/Reports/TaxReports/di/servicelocator";
import { DownlodTaxReportType } from "@domains/aggregates/interfaces/Reports/iTaxReport";
import { useSelector } from "react-redux";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import EdModal from "@frameworks/web/components/generic/edModal";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import TaxDownloadStatusMob from "../TaxDownloadStatusMob";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
const ShowGains = (props) => {
    const webConfig = useContext(WebConfigContext);
    const { loginOrigin } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const [showLoader, setShowLoader] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [showTableDropdown, setshowTableDropdown] = React.useState(false);
    const [elssPopUp, setElssPopUp] = useState(false);
    const downloadStatus = useSelector((state) => state.taxReport.downloadStatus);
    const navigate = useNavigate();
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginOrigin !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const TAXDownloadDropDown = [
        {
            title: "Tax Report",
            value: "TaxReport",
            onClick: () => {
                let baseURL = "/taxDownload?fromDate=" +
                    moment(props.fromDate).format("D-MMM-YY") +
                    "&toDate=" +
                    moment(props.toDate).format("D-MMM-YY");
                let url = props.accCode
                    ? `${baseURL}&family=${window.btoa(props === null || props === void 0 ? void 0 : props.accCode)}`
                    : baseURL;
                navigate(url);
            },
        },
        {
            title: "80C/ELSS",
            value: "80C",
            onClick: () => {
                setElssPopUp(true);
                setshowTableDropdown(false);
            },
        },
        {
            title: "TCS TDS",
            value: "TCSTDS",
            onClick: () => {
                let baseURL = "/taxDownload?fromDate=" +
                    moment(props.fromDate).format("D-MMM-YY") +
                    "&toDate=" +
                    moment(props.toDate).format("D-MMM-YY") +
                    "&urlParts=" +
                    "/tcstds";
                let url = props.accCode
                    ? `${baseURL}&family=${window.btoa(props === null || props === void 0 ? void 0 : props.accCode)}`
                    : baseURL;
                navigate(url);
            },
        },
        {
            title: "Delayed payment charges",
            value: "DPCash",
            onClick: () => {
                let baseURL = "/taxDownload?fromDate=" +
                    moment(props.fromDate).format("D-MMM-YY") +
                    "&toDate=" +
                    moment(props.toDate).format("D-MMM-YY") +
                    "&usetaxDPURL=" +
                    "true" +
                    "&urlParts=" +
                    "/cash";
                let url = props.accCode
                    ? `${baseURL}&family=${window.btoa(props === null || props === void 0 ? void 0 : props.accCode)}`
                    : baseURL;
                navigate(url);
            },
        },
        {
            title: "DP Bills",
            value: DownlodTaxReportType.DPBill,
            onClick: () => {
                let baseURL = "/taxDownload?fromDate=" +
                    moment(props.fromDate).format("D-MMM-YY") +
                    "&toDate=" +
                    moment(props.toDate).format("D-MMM-YY") +
                    "&usetaxDPURL=" +
                    "true" +
                    "&urlParts=" +
                    "/bills";
                let url = props.accCode
                    ? `${baseURL}&family=${window.btoa(props === null || props === void 0 ? void 0 : props.accCode)}`
                    : baseURL;
                navigate(url, {
                    state: {
                        showDPIDDropDown: true,
                    },
                });
            },
        },
    ];
    const initiateELSSDownload = () => {
        let download = {
            fromDate: moment(props.fromDate).format("yyyy-MM-DD"),
            toDate: moment(props.toDate).format("yyyy-MM-DD"),
            reportType: ReportType.PDF,
            urlParts: "/elss",
        };
        if (props === null || props === void 0 ? void 0 : props.accCode)
            download.accodes = props === null || props === void 0 ? void 0 : props.accCode;
        if (webConfig.passwordProtectedDownloadReports)
            download.isPwdProtected = true;
        di.taxReport.downloadAndSendReportTax(null, download);
        setshowTableDropdown(false);
        setElssPopUp(false);
        setShowLoader(true);
    };
    React.useEffect(() => {
        if (downloadStatus && (downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) !== null && showLoader) {
            setShowLoader(false);
            if ((downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) === true)
                setDownloadSuccess(true);
            else
                setDownloadFail(true);
        }
    }, [downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "show-gains-container" },
            React.createElement("div", { className: "show-gains w-100 d-flex justify-content-end align-item-center" },
                React.createElement("span", { onClick: () => {
                        if (!props.shimmer)
                            setshowTableDropdown(!showTableDropdown);
                    } },
                    React.createElement("div", { className: "download-btn downloads" },
                        React.createElement("i", { className: "edel-icon-bold-download " }),
                        "Download"))),
            React.createElement(Drawer, { isVisible: showTableDropdown, onClose: () => setshowTableDropdown(false), hideScrollbars: true, className: "drawer__handle-wrapper backgroundcolor_bluedrawer" },
                React.createElement(DownloadDropDown, { setShowTableDropdown: setshowTableDropdown, bodyList: TAXDownloadDropDown })),
            elssPopUp && (React.createElement(EdModal, { show: elssPopUp, setShow: setElssPopUp, showFooter: false, modalTitle: "", title: "Download ELSS", size: "modal-dialog-centered" },
                !isClientLogin && React.createElement(PANPassword, null),
                React.createElement("div", { className: "d-flex justify-content-center align-items-center mt-3" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", onClick: initiateELSSDownload, type: "submit", value: "Download", className: "py-2 px-3" }, "Download")))),
            React.createElement(TaxDownloadStatusMob, { showLoader: showLoader, operation: "download", closeDrawerLoader: () => setShowLoader(false), downloadSuccess: downloadSuccess, closeDrawerDownloadS: () => setDownloadSuccess(false), downloadFail: downloadFail, closeDrawerFail: () => setDownloadFail(false), goBack: () => { } }))));
};
export default ShowGains;
